import { useEffect } from "react";
import { useLang } from "@/i18n/LanguageContext";

const BASE_TITLE = "UniversHeal";

// Localized page title + meta description. When the language changes, the
// translated strings passed by each page re-render and the head updates.
export const usePageMeta = (title, description) => {
    const { langMeta } = useLang();
    useEffect(() => {
        document.title = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;
        const setMeta = (attr, key, content) => {
            if (!content) return;
            let meta = document.querySelector(`meta[${attr}="${key}"]`);
            if (!meta) {
                meta = document.createElement("meta");
                meta.setAttribute(attr, key);
                document.head.appendChild(meta);
            }
            meta.setAttribute("content", content);
        };
        setMeta("name", "description", description);
        setMeta("property", "og:title", document.title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:locale", langMeta.ogLocale);
        document.documentElement.lang = langMeta.htmlLang;
    }, [title, description, langMeta]);
};
